import React from "react";
import * as Dropdown from "../dropdown/index";
import Checkbox from "../input/Checkbox";
import { withTranslation } from "react-i18next";
import Chip from "../input/Chip";
// // Component SelectMultiple props
// options : [{"key", "label"}]
// optionDefault
// required
// onChange
// name
// id

class SelectMultiple extends React.Component {
  constructor(props) {
    super(props);
    const initialValue = this.props.value || "";
    const valuesArray = this.getValuesFromString(initialValue);
    this.state = {
      label: this.getDisplayLabel(valuesArray),
      selectedValues: valuesArray,
      value: initialValue,
    };
  }

  getValuesFromString(valueString) {
    if (!valueString || !this.props.options) return [];
    const valueArray = valueString.split(';').filter(v => v.trim() !== '');
    return valueArray.map(v => {
      const opt = this.props.options.find(o => o.value === v.trim());
      return opt ? opt.value : v.trim();
    });
  }

  getDisplayLabel(selectedValues) {
    if (!selectedValues || selectedValues.length === 0) return "";

    const firstOpt = this.props.options?.find(o => o.value === selectedValues[0]);
    let label = firstOpt ? firstOpt.label : selectedValues[0];
    if (selectedValues.length >= 2) {
      label += ", ...";
    }
    return label;
  }

  onChange(optionValue, checked) {
    let selectedValues = [...this.state.selectedValues];

    if (optionValue === "all") {
      if (
        !this.props.options ||
        (this.props.options && selectedValues.length === this.props.options.filter(x => x.value !== '').length)
      ) {
        selectedValues = [];
      } else {
        selectedValues = this.props.options ? [...this.props.options.filter(x => x.value !== '').map((opt) => opt.value)] : [];
      }
    } else {
      if (checked && !selectedValues.includes(optionValue)) {
          selectedValues.push(optionValue);
      } else {
        selectedValues = selectedValues.filter((v) => v !== optionValue);
      }
    }

    const valueString = selectedValues.join(';'); // Hubspot format is ';'
    const displayLabel = this.getDisplayLabel(selectedValues);

    this.setState({ label: displayLabel, selectedValues, value: valueString });
    this.props.onChange(valueString);
  }

  componentDidMount() {
    const initialValue = this.props.value || "";
    const valuesArray = this.getValuesFromString(initialValue);
    this.setState({
      selectedValues: valuesArray,
      label: this.getDisplayLabel(valuesArray),
      value: initialValue
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const valuesArray = this.getValuesFromString(this.props.value);
      this.setState({
        selectedValues: valuesArray,
        label: this.getDisplayLabel(valuesArray),
        value: this.props.value
      });
    }
  }

  render() {
    return this.props.options ? (
      <>
        <Dropdown.DropdownButton
          label={
            this.state.label !== "" ? this.state.label : this.props.t("Select")
          }
          styleButton={this.props.styleButton}
          keepOpenOnSelect={true}
          {...this.props}
        >
          <div className="overflow-y-auto max-h-64 2xl:max-h-80 shadow-lg rounded-lg border border-gray-200">
            <div
              key="all"
              className="dropdown-item flex items-center px-4 py-3 text-sm font-medium text-gray-900 hover:bg-primary-perso transition-colors duration-150 border-b border-gray-200 sticky top-0 bg-white z-10"
            >
              <Checkbox
                value={
                  this.state.selectedValues
                    ? this.state.selectedValues.length === this.props.options.filter(x => x.value !== '').length
                    : false
                }
                onChange={(value) => this.onChange("all", value)}
              />
              <span className="ml-3">{this.props.t("Select All")}</span>
            </div>
            {this.props.options.map((opt, key) => {
              if (!opt || opt.value === "") return null;
              const isSelected = this.state.selectedValues?.includes(opt.value);
              return (
                <div
                  key={opt.value}
                  className={`dropdown-item flex items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-primary-perso transition-colors duration-150 border-b border-gray-100 last:border-b-0 ${isSelected ? "bg-primary-50" : ""
                    }`}
                >
                  <Checkbox
                    value={isSelected}
                    onChange={(value) => this.onChange(opt.value, value)}
                  />
                  {opt.render ? (
                    opt.render()
                  ) : (
                    <span className="ml-3">{opt.label}</span>
                  )}
                </div>
              );
            })}
          </div>
        </Dropdown.DropdownButton>
        {this.state.selectedValues && this.state.selectedValues.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-2">
            {this.state.selectedValues.map((value, index) => {
              const option = this.props.options.find(opt => opt.value === value);
              const label = option ? option.label : value;
              return (
                <Chip
                  key={index}
                  value={value}
                  label={label}
                  onChange={(val, isSelected) => this.onChange(val, isSelected)}
                />
              );
            })}
          </div>
        )}
      </>
    ) : (
      ""
    );
  }
}

export default withTranslation()(SelectMultiple);
